/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — the circles use a fixed, evenly-overlapping layout, and the true counts are printed in each region. Area-proportional Venn diagrams are a harder, separate problem.`)
};

const es_venn_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — los círculos usan un diseño fijo y uniformemente superpuesto, y los recuentos reales se imprimen en cada región. Los diagramas de Venn proporcionales por área son un problema aparte y más difícil.`)
};

const de_venn_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein — die Kreise verwenden ein festes, gleichmäßig überlappendes Layout, und die tatsächlichen Anzahlen werden in jeder Region ausgegeben. Flächenproportionale Venn-Diagramme sind ein schwierigeres, separates Problem.`)
};

const nl_venn_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee — de cirkels gebruiken een vaste, gelijkmatig overlappende lay-out, en de werkelijke aantallen worden in elke regio afgedrukt. Oppervlakte-proportionele Venn-diagrammen zijn een moeilijker, apart probleem.`)
};

const fr_venn_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non — les cercles utilisent une disposition fixe et uniformément chevauchante, et les véritables décomptes sont affichés dans chaque région. Les diagrammes de Venn proportionnels en surface sont un problème distinct et plus complexe.`)
};

const it_venn_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — i cerchi usano un layout fisso e uniformemente sovrapposto, e i conteggi reali sono stampati in ogni regione. I diagrammi di Venn proporzionali per area sono un problema diverso e più complesso.`)
};

const pt_br2_venn_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — os círculos usam um layout fixo e uniformemente sobreposto, e as contagens reais são exibidas em cada região. Diagramas de Venn proporcionais à área são um problema separado e mais difícil.`)
};

const pt_venn_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — os círculos usam um esquema fixo, com sobreposição uniforme, e as contagens reais são apresentadas em cada região. Os diagramas de Venn com área proporcional são um problema separado e mais complexo.`)
};

const ja_venn_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ — 円は固定の均等な重なりレイアウトを使用し、実際の件数は各領域に数値として表示されます。面積比例のベン図はより難しい別の問題です。`)
};

const zh_venn_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是——圆圈使用固定的、均匀重叠的布局，真实数量会打印在每个区域中。面积成比例的维恩图是一个更难的独立问题。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_faq_a3", locale)
	if (locale === "en") return en_venn_faq_a3(inputs)
	if (locale === "es") return es_venn_faq_a3(inputs)
	if (locale === "de") return de_venn_faq_a3(inputs)
	if (locale === "nl") return nl_venn_faq_a3(inputs)
	if (locale === "fr") return fr_venn_faq_a3(inputs)
	if (locale === "it") return it_venn_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_venn_faq_a3(inputs)
	if (locale === "pt") return pt_venn_faq_a3(inputs)
	if (locale === "ja") return ja_venn_faq_a3(inputs)
	return zh_venn_faq_a3(inputs)
};